import { requestPDServer } from '@/utils/fetchResponse';
import Cookies from 'js-cookie';
// 用于查询聊天对象的资料
const myBaseUrl = process.env.VUE_APP_BASE_API;
// const userInfo = store.getters['socket/getUserInfo'](platformUserId);

function setCookie() {
  const activeUser = localStorage.getItem('activeUser');
  if (activeUser) {
    const user = JSON.parse(activeUser);
    Cookies.set('tld-token', user.pdToken);
  }
}

/**
 * 聊天用户资料卡
 * {"ids":[104474193]}
 */
export const getConnectionsProfiles = (data, options = {}) => {
  data.ids = data.ids.map((id) => Number(id));
  return requestPDServer('/platform/connections/profiles', data, options);
};
/**
 * 聊天用户与我的语音记录
 * {"idRegularUser":30339782,"idLastMessage":0,"limit":15}
 */
export const getChatDialogMediaAudios = (data) => {
  return requestPDServer('/platform/chat/dialog/media/audios', data);
};
/**
 * 聊天用户与我的视频列表(封面)
 * {"idRegularUser":30339782,"idLastMessage":0,"limit":10}
 */
export const getChatDialogMediaVideos = (data) => {
  return requestPDServer('/platform/chat/dialog/media/videos', data);
};
/**
 * 聊天用户与我的视频
 * 参数：视频列表返回的视频id
 */
export const getProfileVideo = (data) => {
  return requestPDServer(`/platform/profile/video/${data}`, {});
};
/**
 * 好友照片接口
 * 参数：{"idRegularUser":91934905,"idLastMessage":0,"limit":15}
 * idRegularUser好友id
 * idLastMessage为分页依据，初值为0，后续来自于上次请求的最后一个（或几个）对象的idMessage字段，例如：41339939406
 * limit：查询限制的消息数量 （注：可能会获取超过limit数量的对象，因为获取到的对象是以id为唯一标识的，但是limit限制的是idMessage的数量，但是同一条消息中可以含有多个图片。也就是id和idMessage是多对一的关系。）
 */
export const getChatDialogMediaPhotos = (data) => {
  return requestPDServer('/platform/chat/dialog/media/photos', data);
};
